import { useState } from "react";
import { Link } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { LogOut, Crown, User as UserIcon, CreditCard, Sparkles } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { clearTourSeen } from "@/components/OnboardingTour";

export default function UserMenu() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  if (!user) return null;
  const initial = (user.name || user.email)?.[0]?.toUpperCase() || "?";

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="user-menu-trigger"
          className="flex h-9 items-center gap-2 rounded-full border border-[#E6E2D8] bg-white px-2 pr-3 text-sm font-medium text-slate-700 transition-colors hover:border-slate-300"
        >
          {user.picture ? (
            <img
              src={user.picture}
              alt=""
              className="h-6 w-6 rounded-full object-cover"
              referrerPolicy="no-referrer"
            />
          ) : (
            <span className="flex h-6 w-6 items-center justify-center rounded-full bg-indigo-600 text-[11px] font-bold text-white">
              {initial}
            </span>
          )}
          <span className="hidden max-w-[120px] truncate sm:inline">
            {user.name || user.email}
          </span>
          {user.is_pro && (
            <Crown className="h-3.5 w-3.5 text-amber-500" />
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel className="flex flex-col gap-0.5">
          <span className="text-sm font-semibold text-[#1A1D20]">
            {user.name}
          </span>
          <span className="truncate text-xs font-normal text-slate-500">
            {user.email}
          </span>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <Link
            to="/pricing"
            data-testid="menu-pricing"
            className="flex items-center gap-2"
          >
            {user.is_pro ? (
              <Crown className="h-4 w-4 text-amber-500" />
            ) : (
              <CreditCard className="h-4 w-4" />
            )}
            {user.is_pro ? "Manage plan" : "Upgrade to Pro"}
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem
          data-testid="menu-restart-tour"
          onClick={() => {
            clearTourSeen();
            window.dispatchEvent(new Event("clarityscribe:start-tour"));
          }}
          className="flex items-center gap-2"
        >
          <Sparkles className="h-4 w-4 text-indigo-600" />
          Show quick tour
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          data-testid="menu-logout"
          onClick={logout}
          className="text-red-600 focus:text-red-700"
        >
          <LogOut className="mr-2 h-4 w-4" />
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
